<script>
  export default {
    name: 't-image-text',
    props: {
      horizontal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      classes() {
        const classes = ['flex', 'gap-1']
        if (!this.horizontal) classes.push('flex-col')
        return classes
      }
    },
    render(h) {
      return h(
        'div',
        {
          class: this.classes
        },
        this.$slots.default
      )
    }
  }
</script>
